import { useCurveModelStore } from "@/modules/booking_experts/store";
import PriceModelCurveBaseDataDO = Modules.BookingExperts.Data.PriceModelCurve.PriceModelCurveBaseDataDO;
import { Point } from "chart.js";

export function createBezierCurve(
	days: number,
	targetPercentage: number
): Point[] {
	const points: Point[] = [];

	// Control points for smooth S-curve
	const controls = [
		{ x: days, y: 0 },
		{ x: days * 0.75, y: 0 },
		{ x: days * 0.25, y: targetPercentage },
		{ x: 0, y: targetPercentage },
	];

	// Generate points along bezier curve
	for (let i = 0; i <= 12; i++) {
		const t = i / 12;
		const [p0, p1, p2, p3] = controls;

		const bezier = (t: number, ...points: number[]) =>
			Math.pow(1 - t, 3) * points[0] +
			3 * Math.pow(1 - t, 2) * t * points[1] +
			3 * (1 - t) * Math.pow(t, 2) * points[2] +
			Math.pow(t, 3) * points[3];

		points.push({
			x: Math.round(bezier(t, p0.x, p1.x, p2.x, p3.x)),
			y: Math.min(100, Math.max(0, bezier(t, p0.y, p1.y, p2.y, p3.y))),
		});
	}

	return points;
}

export function colorForFactor(f: number | undefined | null): string {
	const neutral = "#dddddd";
	if (!Number.isFinite(f)) return neutral;

	const table = [
		{ v: 0.5, color: "#D42F2F" },
		{ v: 0.6, color: "#D75B5B" },
		{ v: 0.7, color: "#D87171" },
		{ v: 0.8, color: "#D98686" },
		{ v: 0.9, color: "#DBB2B2" },
		{ v: 1.0, color: neutral },
		{ v: 1.1, color: "#B1D8B0" },
		{ v: 1.2, color: "#84D282" },
		{ v: 1.3, color: "#6ECF6B" },
		{ v: 1.4, color: "#58CC54" },
		{ v: 1.5, color: "#2BC626" },
	];

	return table.reduce((best, cur) =>
		Math.abs(cur.v - f) < Math.abs(best.v - f) ? cur : best
	).color;
}

export function colorForAbsoluteOffset(f: number | null | undefined): string {
	const neutral = "#dddddd";
	if (f == null) return neutral;
	if (!Number.isFinite(f)) return neutral;
	const table = [
		{ v: -500, color: "#D42F2F" },
		{ v: -400, color: "#D75B5B" },
		{ v: -300, color: "#D87171" },
		{ v: -200, color: "#D98686" },
		{ v: -1, color: "#DBB2B2" },
		{ v: 0, color: neutral },
		{ v: 1, color: "#B1D8B0" },
		{ v: 200, color: "#84D282" },
		{ v: 300, color: "#6ECF6B" },
		{ v: 400, color: "#58CC54" },
		{ v: 500, color: "#2BC626" },
	];

	return table.reduce((best, cur) =>
		Math.abs(cur.v - f) < Math.abs(best.v - f) ? cur : best
	).color;
}
